/* eslint func-style: "off" */

import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  //actions
  FETCH_DETECT_STREAMS,
  FETCH_CAMPAIGN,
  UPDATE_CAMPAIGN,
  // action creators
  fetchDetectStreamsSucceeded, fetchDetectStreamsFailed,
  fetchCampaignSucceeded, fetchCampaignFailed,
  updateCampaignSucceeded, updateCampaignFailed,
} from './DetectSettings.ducks';
import apiClient from 'helpers/apiClient';

const fetchDetectStreams = function* () {
  try {
    const path = '/api/detect-streams';
    const payload = yield call(apiClient, path);
    payload.forEach((detectStream) => {
      detectStream.value = detectStream.id;
      detectStream.label = detectStream.name;
    });
    yield put(fetchDetectStreamsSucceeded(payload));
  } catch (e) {
    yield put(fetchDetectStreamsFailed(e.body));
  }
};

const fetchCampaign = function* ({ payload: { accountId, campaignId } }) {
  try {
    const path = `/api/accounts/${accountId}/campaigns/${campaignId}`;
    const payload = yield call(apiClient, path);
    yield put(fetchCampaignSucceeded(payload));
  } catch (e) {
    yield put(fetchCampaignFailed(e.body));
  }
};

const updateCampaign = function* ({payload: campaign}) {
  try {
    const path = `/api/accounts/${campaign.accountId}/campaigns/${campaign.id}`;
    const payload = yield call(apiClient, path, {
      method: 'PUT',
      body: JSON.stringify({ detectStreams: campaign.detectStreams })
    });
    yield put(updateCampaignSucceeded(payload));
    Account.toastrNotifications._successMessage({
      success_title: '',
      success_message: 'Your Detect Stream settings have been updated successfully!'
    });
  } catch (e) {
    yield put(updateCampaignFailed(e.body));
    Account.toastrNotifications._errorMessage({
      error_title: '',
      error_message: 'There was a problem updating your Detect Stream settings.'
    });
  }
};

const fetchDetectStreamsSaga = function* () {
  yield takeLatest( FETCH_DETECT_STREAMS, fetchDetectStreams);
};

const fetchCampaignSaga = function* () {
  yield takeLatest( FETCH_CAMPAIGN, fetchCampaign);
};

const updateCampaignSaga = function* () {
  yield takeLatest( UPDATE_CAMPAIGN, updateCampaign);
};

const sagas = function* () {
  yield all([
    fork(fetchDetectStreamsSaga),
    fork(fetchCampaignSaga),
    fork(updateCampaignSaga)
  ]);
};

export {
  fetchDetectStreams,
  fetchCampaign,
  updateCampaign,
  fetchDetectStreamsSaga,
  fetchCampaignSaga,
  updateCampaignSaga
};

export default sagas;
